import { render, staticRenderFns } from "./ProtocolPopup.vue?vue&type=template&id=a6045826&scoped=true&slot-scope=scope&"
import script from "./ProtocolPopup.vue?vue&type=script&lang=js&"
export * from "./ProtocolPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolPopup.vue?vue&type=style&index=0&id=a6045826&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6045826",
  null
  
)

export default component.exports